<template>
  <Discuss />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
import Discuss from "../_components/detail/Discuss";
import BreadcrumClass from "../_components/breadcrumb/BreadcrumbClass";
export default {
  name: "ViewDiscuss",
  data() {
    return {};
  },
  components: {
    Discuss,
    BreadcrumClass
  },
  computed: {
    ...mapGetters({
      subjectLists: STORE_KEY + "/subjectLists"
    })
  },
  mounted() {
    // console.log("ok");
    this.actionGetListSubjectInWeek();
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ["actionGetListSubjectInWeek"])
  }
};
</script>

<style lang="scss" scoped>
// .detail-right{
//     margin:49px 0 100px 0;

// }
.dropdown-account {
  margin-left: 10px;
}
.dropdown button {
  width: 30px;
  background: #f3f6fb;
  color: #879aa9;
  font-size: 14px;
  text-align: center;
  border: 0px;
  padding-left: 0px;
  padding-right: 0px;
  border-radius: 30px;
  height: 30px;
  outline: 0;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #124abe;
  text-decoration: none;
  background: #f3f6fb;
}
.dropdown button:focus {
  background: #f3f6fb !important;
  color: #124abe;
}
.dropdown-toggle::after {
  display: none;
}
.dropdown-menu {
  padding: 0rem 0 0.5rem;
  margin: 0.125rem 0 0;
  box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
  transform: translate3d(-95px, 30px, 0px) !important;
}
@media (max-width: 425px) {
  .dropdown-menu {
    padding: 0rem 0 0.5rem;
    margin: 0.125rem 0 0;
    box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
    transform: translate3d(167px, 30px, 0px) !important;
  }
  .list-class .add-search {
    display: block;
    .btns {
      margin-bottom: 20px;
    }
  }
}
</style>